module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', _vm._l((_vm.layoutGeneralConfig.specialSections), function(item, key) {
    return _c('PageSection', {
      key: key,
      attrs: {
        "section-name": key,
        "config": _vm.layoutGeneralConfig.specialSections,
        "data-set": _vm.layoutDataSet
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4410dba2","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/specialSections/SpecialSections.vue
// module id = a90a7dc491d546d49876
// module chunks = 18